var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "laptop_svg__laptop",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 797.19 787.52"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "laptop_svg__gradient_31",
    x1: 17.4,
    y1: 671.32,
    x2: 59.3,
    y2: 671.32,
    gradientTransform: "matrix(1 0 0 -1 0 790.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ae8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7feaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#62f1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cf2ff"
  })), /*#__PURE__*/React.createElement("style", null, "@keyframes color-ani-01{30%{fill:#8ae8ff}50%{fill:#f46cff}to{fill:#ffd86b}}@keyframes color-ani-02{20%{fill:#9ec6ff}to{fill:#50a0ff}}.laptop_svg__cls-1{fill:#9ec6ff;fill-rule:evenodd;animation:color-ani-02 1s infinite step-start}"))), /*#__PURE__*/React.createElement("path", {
    style: {
      animation: "color-ani-01 3s infinite alternate"
    },
    fill: "url(#laptop_svg__gradient_31)",
    fillRule: "evenodd",
    d: "M17.4 142.65l41.9-24v-22l-41.9 24v22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-1",
    style: {
      animationDelay: ".2s"
    },
    d: "M122.9 129.65l5.9-3.5-5.9-3.4-5.9 3.4 5.9 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-1",
    style: {
      animationDelay: ".4s"
    },
    d: "M71.9 170.15l5.9-3.4-5.9-3.4-6 3.4 6 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-1",
    style: {
      animationDelay: ".6s"
    },
    d: "M112.3 146.85l6-3.5-6-3.4-5.9 3.4 5.9 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "laptop_svg__cls-1",
    style: {
      animationDelay: ".8s"
    },
    d: "M132 146.55l5.9-3.4-5.9-3.5-6 3.5 6 3.4z"
  }));
}

export default SvgLaptop;